export const fixAssetsPath = (str: string): string => {
    return str.replace(/\/?$/, "/");
};
